<template>
	<div class="footer">
		<div class="container">
			<div class="footer-link">
				<a href="http://www.smarthse.cn/#/" target="_blank">企业官网</a>
				<span>|</span>
				<router-link to="/fwtk" >服务条款</router-link>
				<span>|</span>
				<router-link to="/yssm" >隐私证明</router-link>
			</div>
			<div class="footer-info">
				<p>
					<span>增值电信业务经营许可证：浙B2-20170059&nbsp;&nbsp;</span>
					<a target="_blank" href="https://beian.miit.gov.cn/">浙ICP备16005120号-2&nbsp;&nbsp;</a>
					<a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33010602005885">浙公网安备33010602005885号&nbsp;&nbsp;</a>
					<span>©智慧职安环保科技有限公司版权所有</span>
				</p>
			</div>
		</div>
	</div>
</template>

<script>
	export default{
		name: 'zFooter',
		data () {
		    return {
		    
		    }
		},
		mounted(){

		},
		methods:{
			
		}
	}
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/Footer/index.vue